<article class="related-search sim-slider">
    <div class="container">
        <div class="row">
            <div class="slider">
                <div class="row custome-set">
                    <div class="series-box">
                        <div class="simmer-animation series-img"></div>
                        <div class="series-content">
                            <div class="simmer-animation w-100 simmer-animation sim-date"></div>
                            <div class="simmer-animation w-100 simmer-animation sim-date"></div>
                        </div>
                    </div>
                    <div class="series-box">
                        <div class="simmer-animation series-img"></div>
                        <div class="series-content">
                            <div class="simmer-animation w-100 simmer-animation sim-date"></div>
                            <div class="simmer-animation w-100 simmer-animation sim-date"></div>
                        </div>
                    </div>
                    <div class="series-box">
                        <div class="simmer-animation series-img"></div>
                        <div class="series-content">
                            <div class="simmer-animation w-100 simmer-animation sim-date"></div>
                            <div class="simmer-animation w-100 simmer-animation sim-date"></div>
                        </div>
                    </div>
                    <div class="series-box">
                        <div class="simmer-animation series-img"></div>
                        <div class="series-content">
                            <div class="simmer-animation w-100 simmer-animation sim-date"></div>
                            <div class="simmer-animation w-100 simmer-animation sim-date"></div>
                        </div>
                    </div>
                    <div class="series-box">
                        <div class="simmer-animation series-img"></div>
                        <div class="series-content">
                            <div class="simmer-animation w-100 simmer-animation sim-date"></div>
                            <div class="simmer-animation w-100 simmer-animation sim-date"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section-head slide-head">
                <div class="simmer-animation sim-heading"></div>
                <div class="view-all">
                    <div class="simmer-animation sim-link"></div>
                </div>
                <div class="sim-btn-box d-flex align-items-center">
                    <div class="simmer-animation btn mr-3"></div>
                    <div class="simmer-animation btn"></div>
                </div>
            </div>
        </div>
    </div>
</article>
